import Flickity from 'flickity';
import { cursorNavigation } from '../base/carousel';

// Find the element on the page
const element = document.querySelector('.js-instagram-feed');

//
// THE FIX: Use a guard clause to ensure the element exists before running any code.
//
if (element) {
    let carousel;
    let observer = new IntersectionObserver(loadImage);

    carousel = new Flickity(element, {
        cellAlign: 'left',
        contain: true,
        lazyLoad: true,
        pageDots: false,
        prevNextButtons: false,
    });

    cursorNavigation(carousel);

    // Call the initial function safely inside the check
    fetchFeed();

    function fetchFeed() {
        // The dataset.url will only exist if the element was found,
        // but an extra check doesn't hurt.
        if (!element.dataset.url) {
            return;
        }
        return fetch(element.dataset.url)
            .then(response => response.json())
            .then(json => {
                if (!json) {
                    return;
                }

                let placeholderCells = carousel.cells;
                carousel.append(json.media.map(media => createMedia(media)));
                carousel.remove(placeholderCells.map(cell => cell.element));
            }).catch();
    }

    function createMedia(media) {
        let img = document.createElement('img');
        let element = document.createElement('a');

        element.href = media['permalink'];
        element.setAttribute('rel', 'noreferrer');
        element.setAttribute('target', '_blank');
        element.className = 'c-carousel__item c-carousel__item--image c-carousel__item--zoom';

        img.setAttribute('alt', '');
        img.setAttribute('data-ig-src', media['thumbnailUrl'] || media['mediaUrl']);

        element.append(img);
        observer.observe(img);

        return element;
    }

    function loadImage(entries) {
        entries
            .filter(entry => entry.isIntersecting)
            .forEach(entry => {
                let { target } = entry;
                target.src = target.getAttribute('data-ig-src');
                // Optional: stop observing the image once it's loaded
                observer.unobserve(target);
            });
    }
}